import { render, staticRenderFns } from "./sheetProducts.vue?vue&type=template&id=15696fbb&scoped=true"
import script from "./sheetProducts.vue?vue&type=script&lang=js"
export * from "./sheetProducts.vue?vue&type=script&lang=js"
import style0 from "./sheetProducts.vue?vue&type=style&index=0&id=15696fbb&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "15696fbb",
  null
  
)

export default component.exports